// src/merch/sides.js
//
// Side switching lives here (not in store.js) because it must commit any
// in-progress drawing first, and paint.js already imports the store.

import { merch, setSide, copySide } from "./store";
import { commitPaintAsLayer } from "./paint";

export function switchSide(side) {
  if (merch.paint.strokes) commitPaintAsLayer();
  setSide(side);
}

/** Replace the active side with the other side's design. */
export function copyFromSide(from, { mirror = false } = {}) {
  if (merch.paint.strokes) commitPaintAsLayer();
  copySide(from, merch.side, { mirror });
}
